import numeral from 'numeral'
import moment from 'moment'
import * as FW from 'fw/system/FW'
import React from 'react';

// Formatting
export const formatDecimal = function (value, dp) {
    if (value === undefined || value === null || value === "")
        return "";

    if (dp === undefined)
        dp = 2;
    else
        dp = Number(dp);

    let padding = "00";
    if (dp === 0) padding = "";
    if (dp === 1) padding = "0";
    if (dp === 2) padding = "00";
    if (dp === 3) padding = "000";
    if (dp === 4) padding = "0000";
    if (dp === 8) padding = "00000000";

    let expression = "0,0";

    if (padding !== "")
        expression = expression + "." + padding;

    let result = "0." + padding;

    if (value !== "") {
        const numeric = numeral(value);
        result = numeric.format(expression);
    }

    return result;
};

export const formatInt = function (value) {
    return formatDecimal(value, 0);
}

export const formatCurrency = function (value, dp) {
    if (value === undefined || value === null || value === "")
        return "";

    const amount = numeral(value).value();
    const formatted = formatDecimal(Math.abs(amount), dp);

    if (amount >= 0)
        return "$" + formatted;
    else
        return ("($" + formatted + ")");
};

export const formatSignedCurrency = function (value, dp) {
    if (value === undefined || value === null || value === "")
        return "";

    const amount = numeral(value).value();
    const formatted = formatDecimal(Math.abs(amount), dp);

    if (amount >= 0)
        return "$" + formatted;
    else
        return ("-$" + formatted);
};

export const formatPrct = function (value, dp) {

    if (value === undefined || value === null || value === "")
        return "";

    value = value.toString();
    value = value.replace("%", '');

    return formatDecimal(value, dp) + "%";
};

export const formatClientDateTime = function (value) {
    if (!value)
        return "";

    if (value[value.length - 1] === "Z")
        value = value.slice(0, value.length - 1);

    const clientOffsetMinutes = (new Date()).getTimezoneOffset();
    const clientDateTime = moment(value).add(-clientOffsetMinutes, 'minutes');

    return formatDateTime(clientDateTime);
}

export const formatClientDate = function (value) {
    if (!value)
        return "";

    if (value[value.length - 1] === "Z")
        value = value.slice(0, value.length - 1);

    const clientOffsetMinutes = (new Date()).getTimezoneOffset();
    const clientDateTime = moment(value).add(-clientOffsetMinutes, 'minutes');

    return formatDate(clientDateTime);
}

export const formatDateTime = function (value, inputFormat) {
    let outputFormat = FW.getSettings().dateFormat + " " + FW.getSettings().timeFormat;

    return formatDate(value, inputFormat, outputFormat);
};

export const formatDate = function (value, inputFormat, outputFormat) {
    // Set output format
    outputFormat = outputFormat || FW.getSettings().dateFormat;

    // Use format param or defauls
    inputFormat = inputFormat || [moment.ISO_8601, outputFormat];

    // Null, empty, etc..
    if (value === undefined || value === null || value === "" || value === 0)
        return "";

    // Javascript date object
    if (Object.prototype.toString.call(value) === '[object Number]' ||
        Object.prototype.toString.call(value) === '[object Date]') {
        return moment(value).format(outputFormat);
    }

    // Moment object aready?
    if (value._isAMomentObject)
        return moment(value).format(outputFormat);

    // String input
    if (Object.prototype.toString.call(value) === '[object String]') {
        if (value.toString().includes('/'))
            return moment(value, "MM/DD/YYYY[T]HH:mm:ss").format(outputFormat);
        else
            return moment(value, inputFormat).format(outputFormat);
    }

    console.error("Invalid date argument. Can't format date object.");
};

export const formatToday = function () {
    return moment().format(FW.getSettings().dateFormat);
}

export const capitalize = function (s) {
    if (!s)
        return "";

    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export const nl2br = function (s) {
    if (!s)
        return "";

    return s.split('\n').map(str => 
        <React.Fragment>
            {str}<br />
        </React.Fragment>        
    );
}

export const externalLink = function (url,title,targetBlank=true) {
    if (!url)
        return "";
    
    if (!title)
        title = url;

    if (!url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("ftp://"))
        url = "http://" + url;

    return (
        <React.Fragment>
            <a href={url} 
                target={ targetBlank ? "_blank" : ""}
                onClick={e => e.stopPropagation()}>
                {title}
            </a>
        </React.Fragment>);
}

export const formatCount = (count, noun, suffix = 's') => {
    return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

export const formatUsPhoneNumber = function (value) {
    // Get only the numbers from the string
    value = value.replace(/\D/g, "");

    if (value.length > 10)
        value = value.slice(0, 10);

    // Get US/Canadian format
    value = value.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    return value;
}



// WEBPACK FOOTER //
// ./src/fw/misc/Formatting.js